/* ICE · PDP V16/v18: galeria + vídeo, tamanho (variante nativa), oferta por quantidade, provador (boneco gerado), destaques na peça, ICECLUB, barra de compra. */
(function () {
  var $ = function (id) { return document.getElementById(id); };
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var root = $('i-root');
  if (!root) return;

  /* cabeçalho fixo do Dawn: o palco começa abaixo dele */
  var head = document.querySelector('.section-header');
  function setTop() {
    var t = head && getComputedStyle(head).position === 'sticky' ? head.offsetHeight : 0;
    root.style.setProperty('--i-top', t + 'px');
  }
  setTop();
  window.addEventListener('resize', setTop);

  /* galeria */
  var slides = $('i-slides'), rail = $('i-rail'), dots = $('i-dots'), chip = $('i-modelChip');
  var items = slides ? Array.prototype.slice.call(slides.children) : [];
  var pv = $('i-pv'), box = $('i-videoBox'), playBtn = $('i-playBtn'), muteBtn = $('i-muteBtn');
  function playVideo() {
    if (!pv) return;
    pv.muted = false;
    var p = pv.play();
    if (p && p.catch) p.catch(function () { pv.muted = true; if (muteBtn) muteBtn.hidden = false; pv.play().catch(function () {}); });
  }
  function stopVideo() { if (pv && !pv.paused) pv.pause(); }
  items.forEach(function (s, i) {
    var b = document.createElement('button');
    b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-label', 'Foto ' + (i + 1));
    b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
    var im = document.createElement('img'); im.src = s.dataset.thumb || ''; im.alt = ''; im.loading = 'lazy';
    if (s.hasAttribute('data-video')) b.classList.add('i-is-video');
    b.appendChild(im);
    b.addEventListener('click', function () { slides.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); });
    rail.appendChild(b);
    var d = document.createElement('i'); if (i === 0) d.className = 'i-on'; dots.appendChild(d);
  });
  if (items.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = items.indexOf(e.target);
        each(rail.children, function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        each(dots.children, function (d, j) { d.className = j === i ? 'i-on' : ''; });
        if (chip) chip.classList.toggle('i-on', e.target.hasAttribute('data-model'));
        var cur = rail.children[i];
        if (cur) rail.scrollTop = Math.max(0, cur.offsetTop - rail.clientHeight / 2 + cur.offsetHeight / 2);
        if (e.target.hasAttribute('data-video')) playVideo(); else stopVideo();
      });
    }, { root: slides, threshold: 0.6 });
    items.forEach(function (s) { io.observe(s); });
  }
  if (pv) {
    pv.addEventListener('play', function () { box.classList.add('i-playing'); });
    pv.addEventListener('pause', function () { box.classList.remove('i-playing'); });
    pv.addEventListener('ended', function () { box.classList.remove('i-playing'); pv.currentTime = 0; });
    pv.addEventListener('click', function () { if (pv.paused) playVideo(); else pv.pause(); });
    if (playBtn) playBtn.addEventListener('click', playVideo);
    if (muteBtn) muteBtn.addEventListener('click', function () { pv.muted = false; muteBtn.hidden = true; });
  }
  document.addEventListener('keydown', function (e) {
    if (!slides || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    if (/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) return;
    var w = slides.clientWidth, i = Math.round(slides.scrollLeft / w) + (e.key === 'ArrowRight' ? 1 : -1);
    i = Math.max(0, Math.min(items.length - 1, i));
    slides.scrollTo({ left: i * w, behavior: 'smooth' });
  });

  /* tamanho: o botão escolhe a variante nativa (id do formulário, preço, URL) */
  var sizes = $('i-sizes'), vid = $('i-vid'), add = $('i-add');
  var price = $('i-price'), inst = $('i-inst'), bprice = $('i-bprice');
  function selectVariant(btn) {
    if (!btn || !vid) return;
    vid.value = btn.dataset.id;
    var ok = btn.dataset.av === 'true';
    if (add) { add.disabled = !ok; add.querySelector('span').textContent = ok ? 'Adicionar ao carrinho' : 'Esgotado'; }
    if (price) price.innerHTML = (btn.dataset.compare ? '<s>' + btn.dataset.compare + '</s>' : '') + '<b>' + btn.dataset.price + '</b>';
    if (inst) inst.textContent = '3x de ' + btn.dataset.inst + ' sem juros';
    if (bprice) bprice.textContent = btn.dataset.price;
    if (qty && btn.dataset.cents) { qty.dataset.cents = btn.dataset.cents; syncQty(); }
    try { var u = new URL(location.href); u.searchParams.set('variant', btn.dataset.id); history.replaceState(null, '', u); } catch (err) {}
  }

  /* mais peças, menos por peça: 1, 2 ou 3 un; a quantidade vai no formulário nativo, total e botão acompanham */
  var qty = $('i-qty'), qtdInput = $('i-qtdInput'), qtyTotal = $('i-qtyTotal');
  function brl(c) { var v = (Math.round(c) / 100).toFixed(2).split('.'); return 'R$ ' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1]; }
  function qtdAtual() { var r = qty && qty.querySelector('input:checked'); return r ? Number(r.value) : 1; }
  function syncQty() {
    if (!qty) return;
    var c = Number(qty.dataset.cents) || 0, p2 = Number(qty.dataset.p2) || 0, p3 = Number(qty.dataset.p3) || 0;
    var e2 = Math.round(c * (100 - p2) / 100), e3 = Math.round(c * (100 - p3) / 100);
    var set = function (k, t) { var el = qty.querySelector('[data-q="' + k + '"]'); if (el) el.textContent = t; };
    set('each1', brl(c)); set('base2', brl(c)); set('base3', brl(c));
    set('each2', brl(e2)); set('each3', brl(e3));
    set('save2', brl(c * 2 - e2 * 2)); set('save3', brl(c * 3 - e3 * 3));
    var n = qtdAtual(), tot = n === 1 ? c : n === 2 ? e2 * 2 : e3 * 3;
    if (qtyTotal) qtyTotal.textContent = brl(tot);
    if (qtdInput) qtdInput.value = n;
    if (add && !add.disabled) add.querySelector('span').textContent = n === 1 ? 'Adicionar ao carrinho' : 'Adicionar ' + n + ' ao carrinho';
    if (bprice) bprice.textContent = brl(tot);
  }
  if (qty) { each(qty.querySelectorAll('input'), function (r) { r.addEventListener('change', syncQty); }); syncQty(); }

  /* medidas da 1ª tabela, lidas pelo nome da coluna (a ordem muda de peça pra peça):
     largura/tórax/cintura · comprimento · manga/abertura da barra. Coluna que não existe some do provador. */
  var SIZES = {}, ORDER = [], DIMS = [-1, -1, -1];
  var ALIAS = { EG: 'XG', XG: 'EG' };
  var tbl = $('i-table');
  if (tbl) {
    var hs = Array.prototype.map.call(tbl.querySelectorAll('thead th'), function (th) { return th.textContent.trim(); });
    var col = function (re) { for (var j = 1; j < hs.length; j++) if (re.test(hs[j].toLowerCase())) return j; return -1; };
    DIMS = [col(/largura|t[oó]rax|cintura|busto/), col(/comprimento/), col(/manga|abertura|barra/)];
    each(tbl.querySelectorAll('tbody tr'), function (tr) {
      var c = tr.children; if (c.length < 2) return;
      var k = c[0].textContent.trim(); ORDER.push(k);
      SIZES[k] = DIMS.map(function (j) { return j > 0 && c[j] ? parseFloat(c[j].textContent.replace(',', '.')) || 0 : null; });
    });
    ['i-dW', 'i-dL', 'i-dS'].forEach(function (id, n) {
      var b = $(id); if (!b) return;
      var j = DIMS[n];
      if (j < 0) { b.parentNode.hidden = true; return; }
      var lb = b.parentNode.querySelector('span'); if (lb) lb.textContent = hs[j];
    });
  }
  function key(s) { return SIZES[s] ? s : (SIZES[ALIAS[s]] ? ALIAS[s] : s); }
  var fit = $('i-sizesFit');
  if (fit) ORDER.forEach(function (k) {
    var b = document.createElement('button'); b.type = 'button'; b.dataset.size = k; b.textContent = k; b.setAttribute('aria-pressed', 'false'); fit.appendChild(b);
  });
  var groups = [sizes, fit].filter(Boolean);
  var dW = $('i-dW'), dL = $('i-dL'), dS = $('i-dS');
  /* boneco: tronco e braços em SVG por altura (fh) e peso relativo (fw); a peça nasce do tronco e muda com o tamanho (d = escolhido - recomendado).
     data-peca na janela: tee (camiseta/polo/moletom), regata (sem manga), baixo (short/calça: só o boneco). */
  var chartEl = $('i-chart'), peca = (chartEl && chartEl.dataset.peca) || 'tee';
  var SH = 46, CH = 42, WH = 39, Y0 = 96, Y2 = 190, FLOOR = 336, ARM_T = 19, WRIST_X = 53;
  var fig = { fw: 1, fh: 1, d: 0 }, figTarget = { fw: 1, fh: 1, d: 0 }, figAnim = null;
  var bodyG = $('i-bodyG'), lowerG = $('i-lowerG'), headG = $('i-headG'), elTorso = $('i-torso'), elArmL = $('i-armL'), elArmR = $('i-armR');
  var elTee = $('i-teePath'), elTension = $('i-teeTension'), elDimW = $('i-dimW'), elDimL = $('i-dimL');
  function n1(v) { return Math.round(v * 10) / 10; }
  function pt(x, y) { return n1(x) + ' ' + n1(y); }
  function armAxis(side, fw) {
    var x0 = 150 + side * (SH * fw - 5), y0 = Y0 + 3, x1 = 150 + side * WRIST_X * fw, y1 = Y2 + 1;
    var dx = x1 - x0, dy = y1 - y0, L = Math.hypot(dx, dy);
    return { x0: x0, y0: y0, x1: x1, y1: y1, ux: dx / L, uy: dy / L, ox: side * dy / L, oy: -side * dx / L };
  }
  function torsoPath(fw) {
    var sh = SH * fw, ch = CH * fw, wh = WH * fw;
    return 'M' + pt(150 - sh, Y0 + 6) + ' Q' + pt(150 - sh, Y0) + ' ' + pt(150 - sh + 10, Y0) + ' H' + n1(150 + sh - 10) + ' Q' + pt(150 + sh, Y0) + ' ' + pt(150 + sh, Y0 + 6)
      + ' C' + pt(150 + ch, Y0 + 34) + ' ' + pt(150 + wh, Y2 - 28) + ' ' + pt(150 + wh, Y2 + 2) + ' H' + n1(150 - wh)
      + ' C' + pt(150 - wh, Y2 - 28) + ' ' + pt(150 - ch, Y0 + 34) + ' ' + pt(150 - sh, Y0 + 6) + ' Z';
  }
  function armPath(side, fw) {
    var a = armAxis(side, fw), t = ARM_T * Math.sqrt(fw) / 2, o = { x: a.ox * t, y: a.oy * t };
    return 'M' + pt(a.x0 - o.x, a.y0 - o.y) + ' L' + pt(a.x1 - o.x, a.y1 - o.y) + ' L' + pt(a.x1 + o.x, a.y1 + o.y) + ' L' + pt(a.x0 + o.x, a.y0 + o.y)
      + ' A' + n1(t) + ' ' + n1(t) + ' 0 0 ' + (side > 0 ? 0 : 1) + ' ' + pt(a.x0 - o.x, a.y0 - o.y) + ' Z';
  }
  function teePaths(fw, d) {
    var loose = Math.max(0, d), tight = Math.max(0, -d), lf = 1 + loose * 0.07;
    var sh = SH * fw + 1.5, ch = CH * fw * lf + 2, wh = (WH * fw + 2) * lf + loose * 1.5;
    var y2 = Y2 + 3 + loose * 3 - tight * 2, slv = peca === 'regata' ? 3 : 42 + loose * 5 - tight * 3, neck = 23 * Math.sqrt(fw);
    if (peca === 'regata') sh = SH * fw - 8;
    function sleeve(side) {
      var a = armAxis(side, fw), t = ARM_T * Math.sqrt(fw) / 2 + 2.5 + loose * 2.2, cx = a.x0 + a.ux * slv, cy = a.y0 + a.uy * slv;
      return { outer: { x: cx + a.ox * t, y: cy + a.oy * t }, inner: { x: cx - a.ox * t, y: cy - a.oy * t } };
    }
    var r = sleeve(1), l = sleeve(-1);
    var tee = 'M' + pt(150 - neck, Y0) + ' Q' + pt(150, Y0 + 18) + ' ' + pt(150 + neck, Y0)
      + ' L' + pt(150 + sh, Y0 + 2) + ' L' + pt(r.outer.x, r.outer.y) + ' L' + pt(r.inner.x, r.inner.y) + ' L' + pt(150 + ch, r.inner.y - 2)
      + ' C' + pt(150 + ch, r.inner.y + 20) + ' ' + pt(150 + wh, y2 - 24) + ' ' + pt(150 + wh, y2) + ' L' + pt(150 - wh, y2)
      + ' C' + pt(150 - wh, y2 - 24) + ' ' + pt(150 - ch, l.inner.y + 20) + ' ' + pt(150 - ch, l.inner.y - 2)
      + ' L' + pt(l.inner.x, l.inner.y) + ' L' + pt(l.outer.x, l.outer.y) + ' L' + pt(150 - sh, Y0 + 2) + ' Z';
    var tension = '';
    for (var k = 1; k <= Math.round(tight); k++) { var ty = Y0 + 30 + k * 9; tension += 'M' + pt(150 - ch + 5, ty) + ' q6 -2.5 12 0 M' + pt(150 + ch - 17, ty) + ' q6 2.5 12 0 '; }
    var dy = Y0 + 32, dx = 150 + sh + 18 + loose * 3;
    return { tee: tee, tension: tension, dimW: 'M' + pt(150 - ch, dy) + ' H' + n1(150 + ch) + ' M' + pt(150 - ch, dy - 4) + ' v8 M' + pt(150 + ch, dy - 4) + ' v8',
      dimL: 'M' + pt(dx, Y0) + ' V' + n1(y2) + ' M' + pt(dx - 4, Y0) + ' h8 M' + pt(dx - 4, y2) + ' h8' };
  }
  function drawFig() {
    if (!bodyG) return;
    var fw = fig.fw, fh = fig.fh;
    bodyG.setAttribute('transform', 'translate(150 ' + FLOOR + ') scale(1 ' + fh.toFixed(3) + ') translate(-150 -' + FLOOR + ')');
    lowerG.setAttribute('transform', 'translate(150 0) scale(' + fw.toFixed(3) + ' 1) translate(-150 0)');
    headG.setAttribute('transform', 'translate(0 ' + n1((FLOOR - Y0) * (1 - fh)) + ')');
    elTorso.setAttribute('d', torsoPath(fw)); elArmL.setAttribute('d', armPath(-1, fw)); elArmR.setAttribute('d', armPath(1, fw));
    if (peca === 'baixo') return;
    var t = teePaths(fw, fig.d);
    elTee.setAttribute('d', t.tee); elTension.setAttribute('d', t.tension); elDimW.setAttribute('d', t.dimW); elDimL.setAttribute('d', t.dimL);
  }
  function animateFig() {
    if (!bodyG) return;
    if (figAnim) cancelAnimationFrame(figAnim);
    var from = { fw: fig.fw, fh: fig.fh, d: fig.d }, t0 = performance.now();
    function step(now) {
      var k = Math.min(1, (now - t0) / 450); k = 1 - Math.pow(1 - k, 3);
      fig.fw = from.fw + (figTarget.fw - from.fw) * k; fig.fh = from.fh + (figTarget.fh - from.fh) * k; fig.d = from.d + (figTarget.d - from.d) * k;
      drawFig(); figAnim = k < 1 ? requestAnimationFrame(step) : null;
    }
    figAnim = requestAnimationFrame(step);
  }
  var recIndex = Math.max(0, ORDER.indexOf('M'));
  var cur = null;
  var dEls = [dW, dL, dS];
  function fmt(n) { return (Math.round(n * 10) / 10).toString().replace('.', ',') + ' cm'; }
  function tween(to) {
    if (!dW) return;
    if (!cur) cur = to.slice();
    var from = cur.slice(), t0 = performance.now();
    function step(now) {
      var k = Math.min(1, (now - t0) / 500); k = 1 - Math.pow(1 - k, 3);
      for (var n = 0; n < 3; n++) {
        if (to[n] === null) continue;
        cur[n] = (from[n] === null ? to[n] : from[n] + (to[n] - from[n]) * k);
        if (dEls[n]) dEls[n].textContent = fmt(cur[n]);
      }
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function setSize(size) {
    var k = key(size);
    groups.forEach(function (g) { each(g.children, function (b) { var s = b.dataset.size; b.setAttribute('aria-pressed', s === size || s === k || s === ALIAS[k] ? 'true' : 'false'); }); });
    if (sizes) {
      var main = sizes.querySelector('[data-size="' + size + '"]') || sizes.querySelector('[data-size="' + (ALIAS[size] || '') + '"]');
      if (main && !main.disabled) selectVariant(main);
    }
    var m = SIZES[k]; if (!m) return;
    var d = ORDER.indexOf(k) - recIndex;
    figTarget.d = d; animateFig();
    tween(m);
  }
  groups.forEach(function (g) {
    g.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b && !b.disabled) setSize(b.dataset.size); });
  });
  drawFig();
  var first = sizes && sizes.querySelector('[aria-pressed="true"]');
  if (first) setSize(first.dataset.size); else if (ORDER.length) setSize(ORDER[0]);

  /* altura + peso → tamanho recomendado (faixas por peso; o modelo das fotos, 1,70 m e 82 kg, veste G) */
  var inH = $('i-inH'), inW = $('i-inW'), rec = $('i-recSize');
  function recomendar() {
    var h = parseFloat(inH.value), p = parseFloat(inW.value);
    if (!(h >= 140) || !(p >= 40) || !ORDER.length) { rec.textContent = '—'; return; }
    var i = p < 66 ? 0 : p < 80 ? 1 : p < 92 ? 2 : p < 104 ? 3 : 4;
    if (h >= 188 && i < 4) i += 1; else if (h <= 165 && i > 0) i -= 1;
    i = Math.min(i, ORDER.length - 1);
    recIndex = i;
    figTarget.fh = Math.max(0.88, Math.min(1.1, h / 180));
    figTarget.fw = Math.max(0.84, Math.min(1.3, Math.sqrt((p / Math.pow(h / 100, 2)) / 24.1)));
    rec.textContent = ORDER[i];
    setSize(ORDER[i]);
  }
  if (inH && inW) { inH.addEventListener('input', recomendar); inW.addEventListener('input', recomendar); }

  /* janela Tamanho: provador + tabela */
  var chart = chartEl, dlg = $('i-dlg');
  if (chart) {
    var views = { fit: $('i-viewFit'), table: $('i-viewTable') };
    var tabs = dlg.querySelectorAll('.i-tabs button');
    var show = function (view) {
      Object.keys(views).forEach(function (k) { views[k].hidden = k !== view; });
      each(tabs, function (t) { t.setAttribute('aria-selected', t.dataset.view === view ? 'true' : 'false'); });
      if (view === 'fit') { dlg.classList.remove('i-open'); void dlg.offsetWidth; dlg.classList.add('i-open'); }
    };
    each(tabs, function (t) { t.addEventListener('click', function () { show(t.dataset.view); }); });
    var open = function (view) { chart.showModal(); show(view); };
    if ($('i-openFit')) $('i-openFit').addEventListener('click', function () { open('fit'); });
    if ($('i-openChart')) $('i-openChart').addEventListener('click', function () { open('table'); });
    $('i-closeChart').addEventListener('click', function () { chart.close(); });
    chart.addEventListener('click', function (e) { if (e.target === chart) chart.close(); });
    chart.addEventListener('close', function () { dlg.classList.remove('i-open'); });
  }

  /* Compre já: adiciona e vai direto ao checkout */
  var buyNow = $('i-buynow');
  if (buyNow && vid) buyNow.addEventListener('click', function () {
    buyNow.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid.value), quantity: qtdAtual() }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); location.href = '/checkout'; })
      .catch(function () { buyNow.disabled = false; if (add) add.click(); });
  });

  /* barra de compra (celular): aparece quando o botão principal sai da tela por cima */
  var bar = $('i-buybar'), add2 = $('i-add2');
  if (add2 && add) add2.addEventListener('click', function () { add.click(); });
  if (bar && add) {
    var ticking = false;
    var syncBar = function () { ticking = false; bar.classList.toggle('i-on', add.getBoundingClientRect().bottom < 0); };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(syncBar); } }, { passive: true });
    syncBar();
  }

  /* ICECLUB: abre a explicação e o selo carimba */
  var icBtn = $('i-iceclubBtn'), icBody = $('i-iceclubBody'), stamps = $('i-stamps');
  if (icBtn) icBtn.addEventListener('click', function () {
    var isOpen = icBody.hidden;
    icBody.hidden = !isOpen;
    icBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    icBtn.textContent = isOpen ? 'Fechar' : 'Como funciona';
    stamps.classList.remove('i-go');
    if (isOpen) setTimeout(function () { stamps.classList.add('i-go'); }, 60);
  });

  /* blocos abaixo (podem carregar depois do hero) */
  function lower() {
    var perf = $('i-perf');
    if (perf && 'IntersectionObserver' in window) new IntersectionObserver(function (es, obs) {
      if (es[0].isIntersecting) { perf.classList.add('i-go'); obs.disconnect(); }
    }, { threshold: 0.3 }).observe(perf);
    else if (perf) perf.classList.add('i-go');

    /* destaques na peça: troca sozinha a cada 3,2 s enquanto está na tela; para quando alguém toca. No celular os cartões deslizam junto. */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fxc = $('i-fxc');
    if (fxc) {
      var pins = Array.prototype.slice.call(fxc.querySelectorAll('.i-fxc__pin'));
      var rows = Array.prototype.slice.call(fxc.querySelectorAll('.i-fxc__item'));
      var list = $('i-fxcList'), count = $('i-fxcCount'), N = rows.length;
      var fxI = 0, fxTimer = null, fxManual = false, fxScrolling = false, fxT;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var carousel = function () { return list.scrollWidth > list.clientWidth + 2; };
      var go = function (i, manual, fromScroll) {
        if (!N) return;
        fxI = (i + N) % N;
        pins.forEach(function (p) { p.setAttribute('aria-pressed', Number(p.dataset.i) === fxI ? 'true' : 'false'); });
        rows.forEach(function (r, j) { r.setAttribute('aria-current', j === fxI ? 'true' : 'false'); });
        if (count) count.textContent = pad(fxI + 1) + ' / ' + pad(N);
        if (manual) { fxManual = true; fxc.classList.remove('i-auto'); clearInterval(fxTimer); fxTimer = null; }
        if (!fromScroll && carousel()) {
          var li = rows[fxI].parentNode; fxScrolling = true;
          list.scrollTo({ left: li.offsetLeft - list.offsetLeft - parseFloat(getComputedStyle(list).paddingLeft), behavior: reduce ? 'auto' : 'smooth' });
          setTimeout(function () { fxScrolling = false; }, 600);
        }
      };
      pins.forEach(function (p) { p.addEventListener('click', function () { go(Number(p.dataset.i), true); }); });
      rows.forEach(function (r) { r.addEventListener('click', function () { go(Number(r.dataset.i), true); }); });
      if ($('i-fxcPrev')) $('i-fxcPrev').addEventListener('click', function () { go(fxI - 1, true); });
      if ($('i-fxcNext')) $('i-fxcNext').addEventListener('click', function () { go(fxI + 1, true); });
      if (list) list.addEventListener('scroll', function () {
        if (fxScrolling || !N) return;
        clearTimeout(fxT);
        fxT = setTimeout(function () { var w = rows[0].parentNode.getBoundingClientRect().width + 6, i = Math.round(list.scrollLeft / w); if (i !== fxI) go(i, true, true); }, 120);
      });
      if (!reduce && N > 1 && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var on = es[0].isIntersecting && !fxManual;
          if (on && fxTimer === null) { fxc.classList.add('i-auto'); fxTimer = setInterval(function () { var r = rows[(fxI + 1) % N]; go(fxI + 1); r.style.animation = 'none'; void r.offsetWidth; r.style.animation = ''; }, 3200); }
          if (!on && fxTimer !== null) { fxc.classList.remove('i-auto'); clearInterval(fxTimer); fxTimer = null; }
        }, { threshold: 0.4 }).observe(fxc);
      }
    }

    var revMore = $('i-revMore');
    if (revMore) revMore.addEventListener('click', function () {
      each(document.querySelectorAll('#i-revList .i-rev[hidden]'), function (li) { li.hidden = false; });
      revMore.hidden = true;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lower); else lower();
})();
